import { supabase } from './supabase';
import type { CrmInfo } from './crm';

/**
 * CRM réseau (brique B) — écriture Supabase via RPC sécurisée `set_tenant_crm`
 * (super_admin only, cf. sql/22_crm.sql). La lecture passe par loadAllTenants
 * (colonnes CRM ajoutées à TENANT_COLUMNS). Logique pure dans crm.ts.
 */

export interface SaveCrmResult {
  ok: boolean;
  error?: string;
}

/** Enregistre la fiche CRM d'un resto. Envoie tous les champs (chaîne vide = effacement). */
export async function saveCrm(tenantId: string, info: CrmInfo): Promise<SaveCrmResult> {
  const { error } = await supabase.rpc('set_tenant_crm', {
    p_tenant_id: tenantId,
    p_manager_name: info.managerName,
    p_manager_phone: info.managerPhone,
    p_manager_email: info.managerEmail,
    p_opened_on: info.openedOn === '' ? null : info.openedOn,
    p_crm_stage: info.stage,
    p_crm_notes: info.notes,
  });
  if (error) {
    return { ok: false, error: `Enregistrement de la fiche CRM impossible : ${error.message}` };
  }
  return { ok: true };
}
